import { getColor } from "@/helpers/colors";
import Vuetify from "@/plugins/vuetify";
import images from "@/helpers/enums/images";

const coreScores = {
  SURVEY: "Survey",
  format: score => {
    if (score == null) {
      return null;
    }
    let value = parseFloat(score) || 0;
    return value * 10;
  },
  reverseFormat: value => {
    if (value == null) {
      return 0;
    }

    let score = parseFloat(value) || 0;
    return score / 10;
  },
  getIcon: score => {
    if (score == null) {
      return "";
    }
    score = (parseFloat(score) || 0).toFixed(1);

    if (score > 8) {
      return "thumb_up";
    } else if (score > 6) {
      return "fiber_manual_record";
    }
    return "thumb_down";
  },
  getColor: score => {
    if (score == null) {
      return Vuetify.framework.theme.themes.light.primary;
    }
    score = (parseFloat(score) || 0).toFixed(1);

    if (score > 8) {
      return Vuetify.framework.theme.themes.light.success;
    } else if (score > 6) {
      return Vuetify.framework.theme.themes.light.lightwarning;
    }
    return Vuetify.framework.theme.themes.light.error;
  },
  getOpacity: score => {
    if (score == null) {
      return 1;
    }
    score = (parseFloat(score) || 0).toFixed(1);

    if (score > 8) {
      return (score - 8) / (10 - 8);
    } else if (score > 6) {
      return ((score - 6) * -1) / 2 + 1;
    }
    return (score * -1) / 6 + 1;
  },
  getColorBackground: score => {
    return getColor(coreScores.getColor(score), 0.1);
  },
  getColumn: score => {
    if (score == null) {
      return 0;
    }
    score = (parseFloat(score) || 0).toFixed(1);

    if (score > 8) {
      return 1;
    } else if (score > 6) {
      return 2;
    }
    return 3;
  },
  getTitle: score => {
    if (score == null) {
      return "None";
    }
    score = (parseFloat(score) || 0).toFixed(1);

    if (score > 8) {
      return "Outstanding";
    } else if (score > 6) {
      return "Okay";
    }
    return "Looking low";
  },
  getCompareValue: (value, compare) => {
    if (value == 0) {
      return 0;
    }
    return ((value - compare) / value) * 100;
  },
  getCompareColor: change => {
    if (change == 0) {
      return "grey";
    }
    return change > 0 ? "success" : "error";
  },
  getCompareIcon: change => {
    if (change == 0) {
      return "remove";
    }
    return change > 0 ? "call_made" : "call_received";
  },
  getEnpsLabel: value => {
    if (value >= 50) {
      return {
        label: "positive",
        color: Vuetify.framework.theme.themes.light.success,
        icon: "mood"
      };
    } else if (value < 0) {
      return {
        label: "negative",
        color: Vuetify.framework.theme.themes.light.error,
        icon: "mood_bad"
      };
    }
    return {
      label: "neutral",
      color: Vuetify.framework.theme.themes.light.lightwarning,
      icon: "sentiment_neutral"
    };
  },
  getEnpsLabelByColumn(column) {
    switch (column) {
      case 1:
        return {
          label: "positive",
          color: Vuetify.framework.theme.themes.light.success,
          icon: "mood",
          name: "Promoter",
          fullName: "Promoter (9-10)"
        };
      case 2:
        return {
          label: "neutral",
          color: Vuetify.framework.theme.themes.light.lightwarning,
          icon: "sentiment_neutral",
          name: "Passive",
          fullName: "Passive (7-8)"
        };
      default:
        return {
          label: "negative",
          color: Vuetify.framework.theme.themes.light.error,
          icon: "mood_bad",
          name: "Detractor",
          fullName: "Detractor (0-6)"
        };
    }
  },
  getOverallImage: value => {
    let col = coreScores.getColumn(coreScores.reverseFormat(value));

    switch (col) {
      case 1:
        return images.OVERALL_CORE_CARD_OUTSTANDING;
      case 2:
        return images.OVERALL_CORE_CARD_OKAY;
      default:
        return images.OVERALL_CORE_CARD_NEEDS_WORK;
    }
  }
};

export default coreScores;
